export default "__VITE_ASSET__7BBEIc_n__"